// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__2WCbW","rootSuccess":"CompleteLink_rootSuccess__h5xYU","rootFailure":"CompleteLink_rootFailure__3S6VZ","isDisabled":"CompleteLink_isDisabled__3eQr0"};